import React from 'react';



type Props = {
  className?: string;
}
export const EmailVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '32' height = '32' viewBox = '0 0 32 32' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
        <path stroke = '#0041A0' strokeWidth = '2.13333' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M10.667 12L12.4803 14.2901C12.9025 14.8236 13.4381 15.2543 14.0474 15.5503C14.6568 15.8463 15.3242 16 16.0003 16C16.6764 16 17.3439 15.8463 17.9532 15.5503C18.5625 15.2543 19.0981 14.8236 19.5203 14.2901L21.3337 12' />
        <path stroke = '#0041A0' strokeWidth = '2.13333' strokeLinecap = 'round' strokeLinejoin = 'round' d = 'M21.3333 5.33337H10.6667C6.98477 5.33337 4 8.31814 4 12V20C4 23.6819 6.98477 26.6667 10.6667 26.6667H21.3333C25.0152 26.6667 28 23.6819 28 20V12C28 8.31814 25.0152 5.33337 21.3333 5.33337Z' />
    </svg>
  );
};
